export const GENERAL_ACCOUNTANT_TITLE = "محاسب عام";

export function canRouteCashEntitlementDisbursement(user) {
  return (
    user?.jobTitle === GENERAL_ACCOUNTANT_TITLE ||
    user?.role === "gm" ||
    user?.role === "admin"
  );
}

export function isCashEntitlementDisbursed(row) {
  return row?.disbursementStatus === "DISBURSED";
}

export function canCancelCashEntitlement(row) {
  return !isCashEntitlementDisbursed(row) && !row?.cancelledAt;
}

export function cashEntitlementSourceLabel(source) {
  if (source === "PAYROLL") return "من البي رول";
  return "يدوي";
}

export function cashEntitlementStatusMeta(row) {
  if (row?.cancelledAt) {
    return { label: "ملغي", className: "" };
  }
  switch (row?.disbursementStatus) {
    case "DISBURSED":
      return { label: "تم الصرف", className: "is-done" };
    case "ASSIGNED":
      return { label: "بانتظار تأكيد الاستلام", className: "is-assigned" };
    case "PENDING_ASSIGNMENT":
      return { label: "بانتظار توجيه الصرف", className: "is-pending" };
    default:
      return { label: row?.disbursementStatus || "—", className: "" };
  }
}

export function formatCashAmount(amount) {
  const value = Number(amount);
  if (Number.isNaN(value)) return "—";
  return `${value.toLocaleString("ar-EG")} ج.م`;
}

export function formatCashDate(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString("ar-EG");
}

export const NO_BRANCH_FILTER = "__no_branch__";
export const NO_DEPARTMENT_FILTER = "__no_department__";

export function employeeBranchKey(emp) {
  return emp?.branchName || emp?.branch?.name || NO_BRANCH_FILTER;
}

export function employeeDepartmentKey(emp) {
  return (
    emp?.departmentName ||
    emp?.department?.name ||
    NO_DEPARTMENT_FILTER
  );
}

export function employeeJobTitle(emp) {
  return String(emp?.jobTitle || "").trim();
}

function uniqueSorted(values) {
  return [...new Set(values.filter(Boolean))].sort((a, b) =>
    a.localeCompare(b, "ar"),
  );
}

export function buildCashEntitlementFilterOptions(employees = []) {
  const branches = uniqueSorted(
    employees.map((emp) => emp?.branchName || emp?.branch?.name),
  );
  const departments = uniqueSorted(
    employees.map((emp) => emp?.departmentName || emp?.department?.name),
  );
  const jobTitles = uniqueSorted(employees.map((emp) => employeeJobTitle(emp)));
  return {
    branches: employees.some((emp) => employeeBranchKey(emp) === NO_BRANCH_FILTER)
      ? [...branches, NO_BRANCH_FILTER]
      : branches,
    departments: employees.some(
      (emp) => employeeDepartmentKey(emp) === NO_DEPARTMENT_FILTER,
    )
      ? [...departments, NO_DEPARTMENT_FILTER]
      : departments,
    jobTitles,
  };
}

export function employeeMatchesCashFilters(
  emp,
  { search = "", branch = "", department = "", jobTitle = "" } = {},
) {
  if (branch && employeeBranchKey(emp) !== branch) return false;
  if (department && employeeDepartmentKey(emp) !== department) return false;
  if (jobTitle && employeeJobTitle(emp) !== jobTitle) return false;
  const q = String(search || "").trim().toLowerCase();
  if (!q) return true;
  const haystack = [
    emp?.name,
    emp?.fullName,
    emp?.code,
    emp?.employeeCode,
    emp?.jobTitle,
    emp?.branchName,
    emp?.departmentName,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
  return haystack.includes(q);
}

export function cashFilterScopeLabel({ branch, department, jobTitle }) {
  const parts = [];
  if (branch) {
    parts.push(
      branch === NO_BRANCH_FILTER ? "بدون فرع" : `فرع ${branch}`,
    );
  }
  if (department) {
    parts.push(
      department === NO_DEPARTMENT_FILTER
        ? "بدون إدارة"
        : `إدارة ${department}`,
    );
  }
  if (jobTitle) parts.push(`مسمى ${jobTitle}`);
  return parts.join(" · ");
}
